import { useState } from "react";
import { useTranslation } from "react-i18next";
import DBModal from "../../../component/global/DBModal";
import CardDetail from "../../CustomerClub/Components/OffersManagment/CardDetailModal/CardDetail";
import DetailStatus from "../../CustomerClub/Components/OffersManagment/CardDetailModal/DetailStatus";
import "../../CustomerClub/Components/OffersManagment/style.scss";

export default function OfferDetailModal({ show, onHide, data }) {
    const { t } = useTranslation();
    const [tab, setTab] = useState("specs");

    return (
        <DBModal
            show={show}
            onHide={onHide}
            minWidth={720}
            className="offer-detail-modal"
        >
            <DBModal.Header
                title={data?.name || t("offers.detail.title")}
                closeBtn={onHide}
                closeLabel={t("offers.editor.cancel")}
            />
            <DBModal.Content>
                <div className="offer-detail-tabs" role="tablist">
                    <button
                        type="button"
                        role="tab"
                        aria-selected={tab === "specs"}
                        className={tab === "specs" ? "is-active" : ""}
                        onClick={() => setTab("specs")}
                    >
                        {t("offers.detail.specs")}
                    </button>
                    <button
                        type="button"
                        role="tab"
                        aria-selected={tab === "status"}
                        className={tab === "status" ? "is-active" : ""}
                        onClick={() => setTab("status")}
                    >
                        {t("offers.detail.status")}
                    </button>
                </div>
                {tab === "specs" ? (
                    <CardDetail data={data} />
                ) : (
                    <DetailStatus id={data?.id} show={show} />
                )}
            </DBModal.Content>
        </DBModal>
    );
}
